"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSET_ID = void 0;
exports.ASSET_ID = '200044';
